import AfterSalesLayout from "../aftersaleslayout/AfterSalesLayout";
import BackBlue from "../../../assets/aftersalesservice_icons/back_blue_icon.svg";
import UserManualOperate from "../../../assets/aftersalesservice_icons/user_manual_operate_icon.svg";
import UnderstandRemote from "../../../assets/aftersalesservice_icons/understand_remote_icon.svg";
import UnderstandRemote1 from "../../../assets/aftersalesservice_icons/understand_remote_1_icon.svg";
import UnderstandRemote2 from "../../../assets/aftersalesservice_icons/understand_remote_2_icon.svg";
import UnderstandRemote3 from "../../../assets/aftersalesservice_icons/understand_remote_3_icon.svg";
import UnderstandRemote4 from "../../../assets/aftersalesservice_icons/understand_remote_4_icon.svg";
import SetTemp from "../../../assets/aftersalesservice_icons/set_temp_icon.svg";
import ChooseRight from "../../../assets/aftersalesservice_icons/choose_right_icon.svg";
import ChooseRight1 from "../../../assets/aftersalesservice_icons/choose_right_1_icon.svg";
import ChooseRight2 from "../../../assets/aftersalesservice_icons/choose_right_2_icon.svg";
import ChooseRight3 from "../../../assets/aftersalesservice_icons/choose_right_3_icon.svg";
import ChooseRight4 from "../../../assets/aftersalesservice_icons/choose_right_4_icon.svg";
import AdjustFan from "../../../assets/aftersalesservice_icons/adjust_fan_icon.svg";
import AdjustFan1 from "../../../assets/aftersalesservice_icons/adjust_fan_1_icon.svg";
import EnhanceComfort from "../../../assets/aftersalesservice_icons/enhance_comfort_icon.svg";
import EnhanceComfort1 from "../../../assets/aftersalesservice_icons/enhance_comfort_1_icon.svg";
import EnhanceComfort2 from "../../../assets/aftersalesservice_icons/enhance_comfort_2_icon.svg";
import EnhanceComfort3 from "../../../assets/aftersalesservice_icons/enhance_comfort_3_icon.svg";
import EnhanceComfort4 from "../../../assets/aftersalesservice_icons/enhance_comfort_4_icon.svg";
import EnhanceComfort5 from "../../../assets/aftersalesservice_icons/enhance_comfort_5_icon.svg";
import CleanSterilize from "../../../assets/aftersalesservice_icons/clean_sterilize_icon.svg";
import CleanSterilize1 from "../../../assets/aftersalesservice_icons/clean_sterilize_1_icon.svg";
import CleanSterilize2 from "../../../assets/aftersalesservice_icons/clean_sterilize_2_icon.svg";
import Caution from "../../../assets/aftersalesservice_icons/caution_icon.png";
import ChildLock from "../../../assets/aftersalesservice_icons/child_lock_icon.svg";
import ChildLock1 from "../../../assets/aftersalesservice_icons/child_lock_1_icon.svg";
import OperateAc from "../../../assets/aftersalesservice_icons/operate_ac_icon.svg";
import OperateAc1 from "../../../assets/aftersalesservice_icons/operate_ac_1_icon.svg";
import OperateAc2 from "../../../assets/aftersalesservice_icons/operate_ac_2_icon.svg";
import OperateAc3 from "../../../assets/aftersalesservice_icons/operate_ac_3_icon.svg";
import OperateAc4 from "../../../assets/aftersalesservice_icons/operate_ac_4_icon.svg";
import OperateAc5 from "../../../assets/aftersalesservice_icons/operate_ac_5_icon.svg";
import FallbackImg from "../../../components/FallbackImg";
import { useLanguage } from "../LanguageContext";

const UserManualOperating = () => {
  const { trans } = useLanguage();

  return (
    <AfterSalesLayout>
      <div
        className="as-user-manual-operate-content"
        id="user_manual_operating_modal"
      >
        <div style={{ padding: "0 31.97px" }}>
          {/* Header */}
          <div className="as-user-manual-operate-container">
            <button
              type="button"
              className="as-back-btn"
              id="user_manual_operating_back"
              onClick={() => window.history.back()}
            >
              <FallbackImg src={BackBlue} alt="backblue" />
              {trans.back_manual}
            </button>
            <div className="as-user-manual-operate-main">
              <FallbackImg src={UserManualOperate} alt="usermanualoperate" />
              <div>
                <div className="as-user-manual-operate-main-title">
                  {trans.operate_instruct}
                </div>
                <div className="as-user-manual-operate-main-text">
                  {trans.operate_instruct_sub_2}
                </div>
              </div>
            </div>
          </div>

          {/* Understand Remote */}
          <div className="as-understand-remote-container">
            <div className="as-understand-remote-title">
              <FallbackImg src={UnderstandRemote} alt="understandremote" />
              <div>{trans.understand_remote}</div>
            </div>

            <div className="as-understand-remote-box">
              <div>{trans.understand_remote_sub_1}</div>
              <div style={{ color: "#59168B" }}>
                {trans.understand_remote_sub_2}
              </div>

              <div className="as-understand-remote-text">
                <FallbackImg src={UnderstandRemote1} alt="understandremote1" />
                <div>
                  <span>{trans.understand_remote_sub_3_span}</span>
                  {trans.understand_remote_sub_3}
                </div>
              </div>
              <div className="as-understand-remote-text">
                <FallbackImg src={UnderstandRemote2} alt="understandremote2" />
                <div>
                  <span>{trans.understand_remote_sub_4_span}</span>
                  {trans.understand_remote_sub_4}
                </div>
              </div>
              <div className="as-understand-remote-text">
                <FallbackImg src={UnderstandRemote3} alt="understandremote3" />
                <div>
                  <span>{trans.understand_remote_sub_5_span}</span>
                  {trans.understand_remote_sub_5}
                </div>
              </div>
              <div className="as-understand-remote-text">
                <FallbackImg src={UnderstandRemote4} alt="understandremote4" />
                <div>
                  <span>{trans.understand_remote_sub_6_span}</span>
                  {trans.understand_remote_sub_6}
                </div>
              </div>
              <div className="as-understand-remote-text">
                <FallbackImg
                  src={AdjustFan1}
                  alt="adjustfan1"
                  style={{
                    width: 16,
                    height: 16,
                    filter:
                      "invert(25%) sepia(85%) saturate(6000%) hue-rotate(265deg) brightness(95%)",
                  }}
                />
                <div>
                  <span>{trans.understand_remote_sub_7_span}</span>
                  {trans.understand_remote_sub_7}
                </div>
              </div>
            </div>

            <div className="as-understand-remote-italic">
              {trans.understand_remote_sub_8}
            </div>
          </div>

          {/* Set Temperature */}
          <div className="as-set-temp-container">
            <div className="as-set-temp-title">
              <FallbackImg src={SetTemp} alt="settemp" />
              <div>{trans.set_temp}</div>
            </div>

            <div className="as-set-temp-box">
              <div>{trans.set_temp_sub_1}</div>
              <div className="as-set-temp-list">
                <ul>
                  <li>
                    {trans.set_temp_sub_2}
                    <span>{trans.set_temp_sub_2_span}</span>
                  </li>
                  <li>{trans.set_temp_sub_3}</li>
                  <li>
                    {trans.set_temp_sub_4}
                    <span>{trans.set_temp_sub_4_span}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Choose Right Mode */}
          <div className="as-choose-right-container">
            <div className="as-choose-right-title">
              <FallbackImg src={ChooseRight} alt="chooseright" />
              <div>{trans.choose_right}</div>
            </div>
            <div className="as-choose-right-subtitle">
              {trans.choose_right_sub_1}
            </div>

            <div className="as-choose-right-box as-blue">
              <FallbackImg src={ChooseRight1} alt="chooseright1" />
              <div className="as-choose-right-box-inner">
                <div style={{ color: "#1C398E" }}>
                  {trans.choose_right_subtitle_1}
                </div>
                <div style={{ fontSize: 13 }}>{trans.choose_right_sub_2}</div>
                <div style={{ color: "#1447E6", fontSize: 13 }}>
                  {trans.choose_right_sub_3}
                </div>
              </div>
            </div>

            <div className="as-choose-right-box as-orange">
              <FallbackImg src={ChooseRight2} alt="chooseright2" />
              <div className="as-choose-right-box-inner">
                <div style={{ color: "#7E2A0C" }}>
                  {trans.choose_right_subtitle_2}
                </div>
                <div style={{ fontSize: 13 }}>{trans.choose_right_sub_4}</div>
                <div style={{ color: "#CA3500", fontSize: 13 }}>
                  {trans.choose_right_sub_5}
                </div>
              </div>
            </div>

            <div className="as-choose-right-box as-grey">
              <FallbackImg src={ChooseRight3} alt="chooseright3" />
              <div className="as-choose-right-box-inner">
                <div style={{ color: "#101828" }}>
                  {trans.choose_right_subtitle_3}
                </div>
                <div style={{ fontSize: 13 }}>{trans.choose_right_sub_6}</div>
                <div style={{ color: "#364153", fontSize: 13 }}>
                  {trans.choose_right_sub_7}
                </div>
              </div>
            </div>

            <div className="as-choose-right-box as-purple">
              <FallbackImg src={ChooseRight4} alt="chooseright4" />
              <div className="as-choose-right-box-inner">
                <div style={{ color: "#59168B" }}>
                  {trans.choose_right_subtitle_4}
                </div>
                <div style={{ fontSize: 13 }}>{trans.choose_right_sub_8}</div>
                <div style={{ color: "#8200DB", fontSize: 13 }}>
                  {trans.choose_right_sub_9}
                </div>
              </div>
            </div>
          </div>

          {/* Adjust Fan */}
          <div className="as-adjust-fan-container">
            <div className="as-adjust-fan-title">
              <FallbackImg src={AdjustFan} alt="adjustfan" />
              <div>{trans.adjust_fan}</div>
            </div>

            <div className="as-adjust-fan-subtitle">
              {trans.adjust_fan_subtitle_1}
            </div>
            <div className="as-adjust-fan-box as-green">
              <div>{trans.adjust_fan_sub_1}</div>
              <div className="as-fan-speed">
                <div className="as-fan-speed-box">Low</div>
                <div>→</div>
                <div className="as-fan-speed-box">Medium</div>
                <div>→</div>
                <div className="as-fan-speed-box">High</div>
                <div>→</div>
                <div className="as-fan-speed-box">Auto</div>
              </div>
              <div className="as-adjust-fan-list">
                <ul>
                  <li>{trans.adjust_fan_sub_2}</li>
                  <li>{trans.adjust_fan_sub_3}</li>
                </ul>
              </div>
            </div>

            <div className="as-adjust-fan-subtitle">
              {trans.adjust_fan_subtitle_2}
            </div>
            <div className="as-adjust-fan-box as-grey">
              <FallbackImg src={AdjustFan1} alt="adjustfan1" />
              <div>
                <div>{trans.adjust_fan_sub_4}</div>
                <div>{trans.adjust_fan_sub_5}</div>
              </div>
            </div>
            <div className="as-adjust-fan-box as-grey">
              <FallbackImg src={AdjustFan1} alt="adjustfan1" />
              <div>
                <div>{trans.adjust_fan_sub_6}</div>
                <div>{trans.adjust_fan_sub_7}</div>
              </div>
            </div>

            <div className="as-adjust-fan-italic">{trans.adjust_fan_sub_8}</div>
          </div>

          {/* Enhance Comfort */}
          <div className="as-enhance-comfort-container">
            <div className="as-enhance-comfort-title">
              <FallbackImg src={EnhanceComfort} alt="enhancecomfort" />
              <div>{trans.enhance_comfort}</div>
            </div>

            <div className="as-enhance-comfort-box as-blue">
              <FallbackImg src={EnhanceComfort1} alt="enhancecomfort1" />
              <div className="as-enhance-comfort-box-inner">
                <div style={{ color: "#312C85" }}>
                  {trans.enhance_comfort_subtitle_1}
                </div>
                <div style={{ fontSize: 13 }}>
                  {trans.enhance_comfort_sub_1}
                </div>
                <div style={{ color: "#432DD7", fontSize: 13 }}>
                  {trans.enhance_comfort_sub_2}
                </div>
              </div>
            </div>

            <div className="as-enhance-comfort-box as-green">
              <FallbackImg src={EnhanceComfort2} alt="enhancecomfort2" />
              <div className="as-enhance-comfort-box-inner">
                <div style={{ color: "#0D542B" }}>
                  {trans.enhance_comfort_subtitle_2}
                </div>
                <div style={{ fontSize: 13 }}>
                  {trans.enhance_comfort_sub_3}
                </div>
                <div style={{ color: "#008236", fontSize: 13 }}>
                  {trans.enhance_comfort_sub_4}
                </div>
              </div>
            </div>

            <div className="as-enhance-comfort-box as-red">
              <FallbackImg src={EnhanceComfort3} alt="enhancecomfort3" />
              <div className="as-enhance-comfort-box-inner">
                <div style={{ color: "#82181A" }}>
                  {trans.enhance_comfort_subtitle_3}
                </div>
                <div style={{ fontSize: 13 }}>
                  {trans.enhance_comfort_sub_5}
                </div>
              </div>
            </div>

            <div className="as-enhance-comfort-box as-grey">
              <FallbackImg src={EnhanceComfort4} alt="enhancecomfort4" />
              <div className="as-enhance-comfort-box-inner">
                <div style={{ color: "#101828" }}>
                  {trans.enhance_comfort_subtitle_4}
                </div>
                <div style={{ fontSize: 13 }}>
                  {trans.enhance_comfort_sub_6}
                </div>
              </div>
            </div>

            <div className="as-enhance-comfort-box as-cyan">
              <FallbackImg src={EnhanceComfort5} alt="enhancecomfort5" />
              <div className="as-enhance-comfort-box-inner">
                <div style={{ color: "#104E64" }}>
                  {trans.enhance_comfort_subtitle_1}
                </div>
                <div style={{ fontSize: 13 }}>
                  {trans.enhance_comfort_sub_7}
                </div>
              </div>
            </div>
          </div>

          {/* Clean & Sterilize */}
          <div className="as-clean-sterilize-container">
            <div className="as-clean-sterilize-title">
              <FallbackImg src={CleanSterilize} alt="cleansterilize" />
              <div>{trans.clean_sterilize}</div>
            </div>
            <div className="as-clean-sterilize-subtitle">
              {trans.clean_sterilize_sub_1}
            </div>

            <div className="as-clean-sterilize-box as-pink">
              <FallbackImg src={CleanSterilize1} alt="cleansterilize1" />
              <div className="as-clean-sterilize-box-inner">
                <div style={{ color: "#861043" }}>
                  {trans.clean_sterilize_subtitle_1}
                </div>
                <div style={{ fontSize: 13 }}>
                  {trans.clean_sterilize_sub_2}
                </div>
                <div style={{ color: "#C6005C", fontSize: 13 }}>
                  {trans.clean_sterilize_sub_3}
                </div>
              </div>
            </div>

            <div className="as-clean-sterilize-box as-red">
              <FallbackImg src={CleanSterilize2} alt="cleansterilize2" />
              <div className="as-clean-sterilize-box-inner">
                <div style={{ color: "#82181A" }}>
                  {trans.clean_sterilize_subtitle_2}
                </div>
                <div style={{ fontSize: 13 }}>
                  {trans.clean_sterilize_sub_4}
                </div>
                <div style={{ color: "#C10007", fontSize: 13 }}>
                  {trans.clean_sterilize_sub_5}
                </div>
              </div>
            </div>

            <div className="as-clean-sterilize-box as-yellow">
              <div>
                <FallbackImg src={Caution} alt="caution" />
                {trans.clean_sterilize_sub_6}
              </div>
            </div>
          </div>

          {/* Child Lock */}
          <div className="as-child-lock-container">
            <div className="as-child-lock-title">
              <FallbackImg src={ChildLock} alt="childlock" />
              <div>{trans.child_lock}</div>
            </div>

            <div className="as-child-lock-box">
              <div>{trans.child_lock_sub_1}</div>
              <div className="as-child-lock-list">
                <ul>
                  <li>{trans.child_lock_sub_2}</li>
                  <li>{trans.child_lock_sub_3}</li>
                </ul>
              </div>
              <div className="as-child-lock-text">
                <FallbackImg src={ChildLock1} alt="childlock1" />
                <div>{trans.child_lock_sub_4}</div>
              </div>
            </div>
          </div>

          {/* Operate AC */}
          <div className="as-operate-ac-container">
            <div className="as-operate-ac-title">
              <FallbackImg src={OperateAc} alt="operateac" />
              <div>{trans.operate_ac}</div>
            </div>
            <div className="as-operate-ac-subtitle">
              {trans.operate_ac_sub_1}
            </div>

            <div className="as-operate-ac-box">
              <FallbackImg src={OperateAc1} alt="operateac1" />
              <div>{trans.operate_ac_sub_2}</div>
            </div>
            <div className="as-operate-ac-box">
              <FallbackImg src={OperateAc2} alt="operateac2" />
              <div>{trans.operate_ac_sub_3}</div>
            </div>
            <div className="as-operate-ac-box">
              <FallbackImg src={OperateAc3} alt="operatea3" />
              <div>{trans.operate_ac_sub_4}</div>
            </div>
            <div className="as-operate-ac-box">
              <FallbackImg src={OperateAc4} alt="operateac4" />
              <div>{trans.operate_ac_sub_5}</div>
            </div>
            <div className="as-operate-ac-box">
              <FallbackImg src={OperateAc5} alt="operateac5" />
              <div>{trans.operate_ac_sub_6}</div>
            </div>
          </div>

          {/* Proper Operate */}
          <div className="as-proper-operate-container">
            {trans.proper_operate}
          </div>
        </div>
      </div>
    </AfterSalesLayout>
  );
};

export default UserManualOperating;
